import { render, staticRenderFns } from "./StudyResultDialog.vue?vue&type=template&id=c2dbbdca&scoped=true&"
import script from "./StudyResultDialog.ts?vue&type=script&lang=ts&"
export * from "./StudyResultDialog.ts?vue&type=script&lang=ts&"
import style0 from "./StudyResultDialog.css?vue&type=style&index=0&id=c2dbbdca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dbbdca",
  null
  
)

export default component.exports